//
// This file is part of the TYPO3 CMS-based extension "memorial".
// (c) Earlybird GmbH <typo3@earlybird.at>
//
export class MapFeature
{
  public type: string = 'Feature';
  public id: string = '';
  public geometry: { [key: string]: any };
  public properties: { [key: string]: any };

  constructor (featureData: { [key: string]: any }) {
    this.id = featureData.id;
    delete featureData.id;
    this.geometry = featureData.geometry;
    delete featureData.geometry;
    this.properties = featureData.properties;
  }
}
